import React from 'react'
import styled from 'styled-components'

import arrowRightDropdownItem from 'assets/svg/arrowRightDropdownItem.svg'
import LinkWithLocale from '../../../LinkWithLocale'
import BadgeDropdown from '../../components/BadgeDropdown'
import { HeaderDropdownItemProps } from './types'

export const HeaderDropdownItem = (props: HeaderDropdownItemProps) => {
  const { text, name, badge, dir, ...rest } = props

  return (
    <StyledDropdownItem propDir={dir} {...rest}>
      <DropDownItemNameWrapper>
        <DropdownItemName>{name}</DropdownItemName>
        {Boolean(badge) && <BadgeDropdown type={badge} />}
      </DropDownItemNameWrapper>
      <DropdownItemText>{text}</DropdownItemText>
    </StyledDropdownItem>
  )
}

const StyledDropdownItem = styled(LinkWithLocale)<{ propDir?: string }>`
  min-height: 88px;
  display: block;
  position: relative;
  width: 100%;
  padding: 0.625rem 0.75rem;
  clear: both;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.normal};
  color: ${({ theme: { colors } }) => colors.dropdownItem};
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  line-height: 1.375;
  transition: color 0.2s, background-color 0.2s;

  &:hover {
    > div > h6 {
      color: ${({ theme: { colors } }) => colors.link};
    }

    text-decoration: none;
    background-color: ${({ theme: { colors } }) => colors.white};

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 2rem;
      border-radius: 0.25rem;
      background-image: url(${arrowRightDropdownItem});
      background-repeat: no-repeat;
      background-position: center;
      background-color: ${({ theme: { colors } }) => colors.newLightColor.vividBlue};

      ${({ propDir }) =>
        propDir !== 'ltr' &&
        ` [dir='rtl'] & {
        left: 0;
        right: unset;
        transform: rotate(180deg);
      }`}
    }
  }
`
export const DropdownItemName = styled.h6`
  color: ${({ theme: { colors } }) => colors.newLightColor.softNavy};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  font-family: 'Gilroy';
`
export const DropdownItemText = styled.p`
  width: 100%;
  margin: 0;
  margin-top: 2px;
  padding-right: 2rem;
  white-space: pre-wrap;
  color: ${({ theme: { colors } }) => colors.newLightColor.softNavy};
  opacity: 0.8;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  font-family: 'Gilroy';
`

const DropDownItemNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 2rem;
`
